/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import {EnvironmentDetails, getEnvironmentDetails} from './env';

/**
 * The `useEnvironmentDetails` hook returns the environment configuration details
 * for the application including the external environment, host environment, and
 * whether the configuration was loaded from an external domain.
 *
 * ```typescript
 *  const details = useEnvironmentDetails();
 *  ...
 *
 *  <Render.If condition={details.isExternal}>
 *    <SomeComponent />
 *  </Render.If>
 * ```
 *
 * @see {@link EnvironmentDetails}
 * @see {@link getEnvironmentDetails}
 * @returns The environment details object containing external environment, host
 *          environment, and an external configuration flag.
 */
const useEnvironmentDetails = (): EnvironmentDetails => (
  getEnvironmentDetails()
);
export default useEnvironmentDetails;
